import styled from 'styled-components';

export const Card = styled.div<{ height?: string; borderless?: boolean; shadowless?: boolean; padding?: string }>`
  background-color: #ffffff;
  border: ${({ borderless }) => (borderless ? 'none' : '1px solid #ddd')};
  border-radius: 6px;
  padding: ${({ padding }) => padding || '20px'};
  box-shadow: ${({ shadowless }) => (shadowless ? 'none' : '0 2px 4px rgba(0, 0, 0, 0.2)')};
  display: flex;
  flex-direction: column;
  transition:
    transform 0.2s,
    box-shadow 0.2s;
  width: 100%;
  min-width: 300px;
  max-width: 100%;
  height: ${({ height }) => (height ? height : '100%')};

  cursor: ${({ onClick }) => (onClick ? 'pointer' : 'default')};
  &:hover {
    box-shadow: ${({ shadowless }) => (shadowless ? 'none' : '0 4px 8px rgba(0, 0, 0, 0.3)')};
  }
`;
